import { v4 as uuidv4 } from 'uuid';
import { TailwindBreakpoint } from './frontendTypes';

export const isFunction = (fn: any) => typeof fn === 'function';
export const isNumber = (n: any) => typeof n === 'number';
export const uniqArr = (arr: any[]) => [...Array.from(new Set(arr))];

export function ellipsisUtil(str: string, len: number): string {
  let q = str || '';
  q = q.length > len ? `${q.substr(0, len).trim()}...` : q;
  return q;
}

/**
 * Check if a given value exists
 *
 * @export
 * @param {*} val
 * @returns {boolean}
 */
export function exists(val: any): boolean {
  return val !== undefined;
}

/**
 * Check if a given value is an array
 *
 * @export
 * @param {*} val
 * @returns {val is any[]}
 */
export function isArray(val: any): val is any[] {
  return Array.isArray(val);
}

/**
 * Check if a given value is an object
 *
 * @export
 * @param {*} val
 * @returns {val is object}
 */
export function isObject(val: any): val is object {
  return typeof val === 'object' && !isArray(val) && val !== null;
}

/**
 * Check if a given value is a string
 *
 * @export
 * @param {*} val
 * @returns {val is string}
 */
export function isString(val: any): val is string {
  return typeof val === 'string';
}

export const getUUID = () => uuidv4();

export const tailwindBreakpointLt = (a: TailwindBreakpoint, b: TailwindBreakpoint): boolean => {
  if (a === b) {
    return false;
  }
  switch (a) {
    case TailwindBreakpoint.SM:
      return [TailwindBreakpoint.MD, TailwindBreakpoint.LG, TailwindBreakpoint.XL, TailwindBreakpoint.XXL].includes(b);
    case TailwindBreakpoint.MD:
      return [TailwindBreakpoint.LG, TailwindBreakpoint.XL, TailwindBreakpoint.XXL].includes(b);
    case TailwindBreakpoint.LG:
      return [TailwindBreakpoint.XL, TailwindBreakpoint.XXL].includes(b);
    case TailwindBreakpoint.XL:
      return b === TailwindBreakpoint.XXL;
    case TailwindBreakpoint.XXL:
      return false;
  }
};

export const cloneArrayWithSwappedElements = <T>(array: T[], indexA: number, indexB: number): T[] => {
  const copy = [...array];
  [copy[indexA], copy[indexB]] = [copy[indexB], copy[indexA]];
  return copy;
};

/**
 * Takes in a hex color, either `#000` or `#000000`, and returns true if the color is light, false if it is dark.
 * @param hexColorParam
 * @returns
 */
export function isHexColorLight(hexColorParam: string): boolean {
  const hexColor = hexColorParam.replace('#', '');
  // Convert 3-digit hex color to 6-digit hex color
  const hex =
    hexColor.length === 3 ? `${hexColor[0].repeat(2)}${hexColor[1].repeat(2)}${hexColor[2].repeat(2)}` : hexColor;

  // Parse hex color to RGB values
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Calculate luminance using relative luminance formula
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Return true if color is light, false if it is dark
  return luminance > 128;
}
